import React from 'react';
import styles from './styles.module.scss';

import { ReactComponent as LogoAnimal } from '../../../assets/icons/certa-libre_maltrato_animal.svg';
import { ReactComponent as LogoAloe } from '../../../assets/icons/certa-aloe.svg';
import { ReactComponent as LogoKL } from '../../../assets/icons/certa-kl.svg';
import { ReactComponent as LogoM } from '../../../assets/icons/certa-m.svg';

const Certificates = ({ cmsData, content, spanish }) => {
  const {
    CertificationAloe,
    CertificationAnimal,
    CertificationKL,
    CertificationM,
  } = cmsData;
  return (
    <div className={styles.container}>
      {(CertificationAloe ||
        CertificationAnimal ||
        CertificationKL ||
        CertificationM) && (
        <h4>
          {spanish
            ? content?.CertificationsSpanish
            : content?.CertificationsEnglish}
        </h4>
      )}
      <div className={styles.content}>
        {CertificationAloe && <LogoAloe />}
        {CertificationAnimal && <LogoAnimal />}
        {CertificationKL && <LogoKL />}
        {CertificationM && <LogoM />}
      </div>
    </div>
  );
};

export default Certificates;
